import { OfficeTransferDetail } from "@/type/core/officeTransfer/officeTransfer.types";
import { createEvent } from "effector";

export const setOfficeTransfer = createEvent<OfficeTransferDetail>(
  "SET_OFFICE_TRANSFER",
);
